module.exports = __webpack_public_path__ + "static/media/bannerMobilr.a1347571.png";